import React, { useState, useEffect, useRef } from 'react';
import useAxios from 'hooks/useAxios';
import ReactStrapTable from 'components/reactStrapTable';
import { dateFormate, cellRendererCheck, fileFormatter } from 'utils/columns';
import DeleteIcon from 'assets/icon/icon-icon-options-delete.svg';
import DeleteHoverIcon from 'assets/icon/icon-icon-options-delete-hover.svg';
import { Button } from 'reactstrap';
import { Formik, Field } from 'formik';
import HoverImage from 'react-hover-image/build';
import Confirm from 'components/Confirm';
import { toast } from 'react-toastify';

const RxComment = (props) => {
  const API = useAxios();
  const { rxNumber, tenantID, coveredEntityID, text = 'Rx Comment' } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const formikRef = useRef();
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [commentId, setCommentId] = useState(-1);

  const fetchClaimComments = async () => {
    setLoading(true);
    try {
      const { data } = await API.get(
        `/${tenantID}/Comments/RxComments/${rxNumber}`,
        {
          hideLoader: true,
        }
      );
      setLoading(false);
      setData(data);
    } catch (error) {
      setLoading(false);
    }
  };
  const cellRenderEdit = (row) => {
    return (
      <div className="d-flex align-items-center">

        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => handleDeleteConfirmation(row)}
        >
          <HoverImage src={DeleteIcon} hoverSrc={DeleteHoverIcon} alt='' />
        </Button>
      </div>
    );
  }
  const deleteRow = async () => {
    handleDeleteConfirmation();

    let result = await API.post(`/${tenantID}/Comments/inactivecomment/${coveredEntityID}/${commentId}`, null, {
      hideLoader: true,
    });
    if (result) {
      toast.success("Item removed successfully");
      fetchClaimComments();
    }
  }
  const handleDeleteConfirmation = async (row) => {
    setDeleteConfirm(!isDeleteConfirm);
    if (row) setCommentId(row.commentID);
  }

  useEffect(() => {
    fetchClaimComments();
  }, []);

  const download = async (file) => {
    const { fileRepositoryID } = file;
    try {
      const { access_token } =
        JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
      setLoading(true);
      const res = await API.get(
        `/${tenantID}/Comments/Download/${parseInt(
          coveredEntityID
        )}/${fileRepositoryID}?access_token=${access_token}`,
        {
          responseType: 'blob',
        }
      );
      setLoading(false);
      if (res.request.responseType === 'blob') {
        window.open(res.request.responseURL);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const columns = [
    {
      dataField: 'delete',
      text: 'Options',
      width: 180,
      cellRenderer: (row) => cellRenderEdit(row),
      show: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: 'comments',
      text: text,
      width: 180,
      show: true,
    },
    {
      dataField: 'createdDate',
      text: 'Created Date',
      width: 60,
      show: true,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },
    {
      dataField: 'createdBy',
      text: 'Created By',
      width: 60,
      show: true,
      cellRenderer: (row) => cellRendererCheck(row.createdBy),
    },
    {
      dataField: 'files',
      text: 'Attachments',
      width: 100,
      show: true,
      cellRenderer: (row) => fileFormatter(row, download),
    },
  ];
  return (
    <>
      <Formik
        innerRef={formikRef}
        enableReinitialize={true}
      >
        <ReactStrapTable
          id='commnets'
          height={30 * data.length}
          columns={columns}
          data={data}
        // loading={loading}
        />
      </Formik>
      <Confirm
        isOpen={isDeleteConfirm}
        loading={loading}
        message='Are you sure you want to delete this comment?'
        onToggle={handleDeleteConfirmation}
        onCancel={handleDeleteConfirmation}
        onContinue={deleteRow}
      />


    </>
  );

};

export default RxComment;
